import i18n from '@/lang/index'

export default [
  {
    permission: ['viewCar'],
    element: '.driver-item-car',
    popover: {
      title: i18n.t('public.Transport_Code'),
      description: i18n.t('public.open_carrier_list'),
      operate: {
        openMenu: 'business'
      }
    },
    onHighlightStarted (element) {
      element.click()
    }
  },
  {
    permission: ['viewCar'],
    element: '.driver-item-trans-code-icon',
    popover: {
      title: i18n.t('public.Transport_Code'),
      description: i18n.t('public.view_transport_Code_desc')
    }
  }
]
